import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
  Alert,
  Divider,
} from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ArcaPageShell from './components/ArcaPageShell';
import { LAYOUT_LABELS } from './utils/slideSchema';
import { DEFAULT_ARCA_SETTINGS, loadArcaSettings, saveArcaSettings } from './utils/arcaStorage';

const TOM_OPTIONS = [
  { value: 'executivo', label: 'Executivo — direto e formal' },
  { value: 'tecnico', label: 'Técnico — detalhado e preciso' },
  { value: 'didatico', label: 'Didático — explicativo e acessível' },
];

export default function ArcaConfiguracoesPage() {
  const [settings, setSettings] = useState(() => loadArcaSettings());
  const [saved, setSaved] = useState(false);

  const patch = (partial) => {
    const next = saveArcaSettings(partial);
    setSettings(next);
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  return (
    <ArcaPageShell
      title="Configurações"
      subtitle="Preferências salvas no seu navegador. A chave Gemini permanece apenas no servidor (backend/.env)."
    >
      {saved && (
        <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>
          Preferências salvas.
        </Alert>
      )}

      <Paper
        elevation={0}
        sx={{
          p: 2,
          mb: 3,
          border: '1px solid #bbf7d0',
          borderRadius: 2,
          bgcolor: '#f0fdf4',
          display: 'flex',
          gap: 1.5,
          alignItems: 'flex-start',
        }}
      >
        <SecurityIcon color="success" sx={{ mt: 0.25 }} />
        <Box>
          <Typography variant="subtitle2" fontWeight={700} color="#166534">
            Segurança
          </Typography>
          <Typography variant="body2" color="#15803d">
            Chaves de API e tokens nunca aparecem no navegador. Todas as chamadas à IA passam por rotas
            backend autenticadas.
          </Typography>
        </Box>
      </Paper>

      <Paper elevation={0} sx={{ border: '1px solid #e2e8f0', borderRadius: 2, bgcolor: '#fff', p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <SettingsOutlinedIcon color="primary" />
          <Typography variant="h6" fontWeight={700}>
            Padrões do workspace
          </Typography>
        </Box>

        <Box sx={{ display: 'grid', gap: 2.5, maxWidth: 480 }}>
          <FormControl fullWidth size="small">
            <InputLabel>Modo de contexto padrão</InputLabel>
            <Select
              label="Modo de contexto padrão"
              value={settings.modoPadrao}
              onChange={(e) => patch({ modoPadrao: e.target.value })}
            >
              <MenuItem value="conectado">Conectado — dados do SGC</MenuItem>
              <MenuItem value="livre">Livre — apenas prompt criativo</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth size="small">
            <InputLabel>Layout padrão de novos slides</InputLabel>
            <Select
              label="Layout padrão de novos slides"
              value={settings.layoutPadrao}
              onChange={(e) => patch({ layoutPadrao: e.target.value })}
            >
              {Object.entries(LAYOUT_LABELS).map(([value, label]) => (
                <MenuItem key={value} value={value}>
                  {label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth size="small">
            <InputLabel>Tom da IA nos prompts</InputLabel>
            <Select
              label="Tom da IA nos prompts"
              value={settings.tomIa}
              onChange={(e) => patch({ tomIa: e.target.value })}
            >
              {TOM_OPTIONS.map((o) => (
                <MenuItem key={o.value} value={o.value}>
                  {o.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Divider />

          <FormControlLabel
            control={
              <Switch
                checked={settings.mostrarDicaIlustracao}
                onChange={(e) => patch({ mostrarDicaIlustracao: e.target.checked })}
              />
            }
            label="Mostrar aviso sobre ilustrações IA (plano pago Gemini)"
          />
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 3 }}>
          Valores padrão restaurados: modo «{DEFAULT_ARCA_SETTINGS.modoPadrao}», layout «
          {LAYOUT_LABELS[DEFAULT_ARCA_SETTINGS.layoutPadrao]}».
        </Typography>
      </Paper>
    </ArcaPageShell>
  );
}
